export default class MainMenu {

    constructor(menuToggle = '.site-header .menu-toggle') {
        this.rootHtml = document.querySelector('html');

        // Setup menu
        this.menuToggle = document.querySelector(menuToggle);
        this.menu = document.querySelector(this.menuToggle.hash);
        this.menuItems = document.querySelectorAll('#main-menu a');

        // Init events
        this.addEvents();
    }

    addEvents ()
    {
        // Toggle menu
        this.menuToggle.addEventListener('click', (e) => this.show(e));

        // SubMenus
        this.menuItems.forEach(el => {

            if(el.classList.contains('menu-item-has-children')) {
                el.classList.add('is-closed'); // Close all at first
                el.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.subMenuClick(event, el);
                });
            } else {
                el.addEventListener('click', (event) => {
                    this.hide(event, el); // hide the menu and continue
                });
            }
        }, this);
    }

    // Toggle a submenu onClick
    subMenuClick (event, el) {
        // Close all items but toggle the one that was clicked
        this.menuItems.forEach(sub => {
            if(sub === el) {
                sub.classList.toggle('is-closed');
            } else {
                sub.classList.add('is-closed');
            }
        });
    }

    // Show-hide the menu
    show (event)
    {
        event.preventDefault(); // not even sure we need this
        this.rootHtml.classList.toggle('menu-on');
    }
    hide (event)
    {
        this.rootHtml.classList.remove('menu-on');
    }
}
